// fetchInterceptor.js

const originalFetch = window.fetch;

window.fetch = async (...args) => {
  const response = await originalFetch(...args);

  if (response.status === 401) {
    localStorage.clear();
    sessionStorage.clear();
    window.location.href = "/restricted-web-access";
  }

  try {
    const clonedResponse = response.clone();
    const data = await clonedResponse.json();

    if (
      data?.success === false &&
      data?.message === "Account is blocked"
    ) {
      localStorage.clear();
      sessionStorage.clear();
      window.location.href = "/restricted-web-access";
    }

  } catch (err) {}

  return response;
};
